var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureChatMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u9875\\u9762-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File",
    transform: "translate(-480 -96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf_line",
    transform: "translate(480 96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MingCute",
    d: "M24,0V24H0V0ZM12.594,23.258l-.012,0-.071.035-.019,0h0l-.015,0-.071-.035a.021.021,0,0,0-.024.005l0,.011-.017.427.005.02.011.012.1.074.015,0h0l.012,0,.1-.074.013-.016h0l0-.017-.017-.427a.021.021,0,0,0-.016-.018Zm.265-.112-.014,0-.185.092-.01.01h0l0,.011.018.429,0,.013h0l.009.007.2.093a.025.025,0,0,0,.028-.008l0-.014-.034-.615a.025.025,0,0,0-.019-.021Zm-.715,0a.023.023,0,0,0-.027.005l-.006.014-.034.615a.023.023,0,0,0,.017.023h.016l.2-.093.009-.008h0l0-.012.018-.429,0-.013h0l-.009-.009Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M13.586,2a2,2,0,0,1,1.284.467l.13.119L19.414,7a2,2,0,0,1,.578,1.238L20,8.414V20a2,2,0,0,1-1.851,1.994L18,22H6a2,2,0,0,1-1.995-1.851L4,20V4A2,2,0,0,1,5.851,2.005L6,2ZM12,4H6V20H18V10H13.5a1.5,1.5,0,0,1-1.493-1.356L12,8.5Zm.988,7.848a6.223,6.223,0,0,0,2.235,3.872,1,1,0,0,1-.988,1.712,6.223,6.223,0,0,0-4.471,0,1,1,0,0,1-.988-1.712,6.222,6.222,0,0,0,2.235-3.872A1,1,0,0,1,12.988,11.848ZM12,14.152l-.689,1.2h1.38Zm2-9.738V8h3.586Z",
    fill: "#09244b",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureChatMediaIcon);
export default __webpack_public_path__ + "static/media/secure-chat-media-icon.5764ee729ea0f925c9cd011f8f360d5f.svg";
export { ForwardRef as ReactComponent };